import { render } from "./HeaderSidebar.vue?vue&type=template&id=7dd92dcc&scoped=true"
import script from "./HeaderSidebar.vue?vue&type=script&lang=js"
export * from "./HeaderSidebar.vue?vue&type=script&lang=js"

import "./HeaderSidebar.vue?vue&type=style&index=0&id=7dd92dcc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3368519796/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd92dcc"]])

export default __exports__